<template>
    <div class="">

        <div class='testimonial-area pt-100 pb-70'>
            <div class="container">

                <div class="section-title">
                    <h2 v-if="!pgLoading">{{ $t('app.testimonials') }}</h2>
                    <h2 v-if="pgLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
                </div>

                <div v-if="pgLoading" class="col-12 row">
                    <div class="col-6">
                        <div class="webkit-animation webkit-none-245"></div>
                    </div>
                    <div class="col-6">
                        <div class="webkit-animation webkit-none-245"></div>
                    </div>
                </div>

                <!--:items="2" -->
                <carousel v-if="!pgLoading && items && items.length" :autoplay="true"
                    :rtl="($i18n.locale == 'ar') ? true : false" :responsive="{ 0: { items: 1 }, 600: { items: 2 }, 900: { items: 2 } }"
                    :loop="true" :margin="60" :nav="false" :dots="true">
                    <div class="item testimonial-content" v-for="(item, idx) in items" :key="idx">
                        <ul>
                            <li v-for="(str, idx) in parseInt(item.star ? item.star : 0)" :key="idx">
                                <i :key="str" class="icofont-star checked"></i>
                            </li>
                        </ul>
                        <h5 v-html="($i18n.locale == 'en') ? item.en.title : item.ar.title"></h5>
                        <p v-html="($i18n.locale == 'en') ? item.en.body : item.ar.body"></p>
                        <i class="icofont-quote-left quote"></i>
                    </div>
                </carousel>

            </div>
        </div>

    </div>
</template>

<script>
import carousel from 'v-owl-carousel'

export default {
    name: 'Testimonials',
    components: {
        carousel
    },
    data() {
        return {
            //
            items: [],
            pgLoading: true,
            refs: 'testimonials'
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                },
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.items = res.data.data.rows;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
